// DiamondNodeModel.ts
import {setInitialNodeSendNotificationData} from '@ReduxActions'
import {PortModelAlignment} from '@projectstorm/react-diagrams'
import {store} from '../../../../store'
import {NodeTypeEnum} from '../../../../types/NodeTypeEnum'
import {removeNodeAndConnectItsParentAndTarget} from '../../utils/NodeEventUtils'
import {CustomNodeModel} from '../CustomNodeModel'
import {SendPushPortModel} from './SendPushPortModel'

// this can be further extended for more complicated node types
export class SendPushNodeModel extends CustomNodeModel {
  constructor(id?: string) {
    const obj = {
      type: NodeTypeEnum.sendPush,
      id,
      extras: {
        name: 'Send Push',
        priority: 3,
        nodeSize: 250,
      },
    }
    if (!id) delete obj.id

    super(obj)

    this.addPort(new SendPushPortModel(PortModelAlignment.TOP))
    this.addPort(new SendPushPortModel(PortModelAlignment.BOTTOM))

    store.dispatch(
      setInitialNodeSendNotificationData({
        id: this.getID(),
        type: NodeTypeEnum.sendPush,
      })
    )
  }

  remove() {
    removeNodeAndConnectItsParentAndTarget(this.getID(), () => super.remove())
  }
}
